// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"36cadc4f","547":"4c66c08b"}[chunkId] + ".chunk.css";
};